export default function StormDamage() {
  const services = [
    {
      icon: 'ri-shield-flash-line',
      title: 'Emergency Tarping',
      description: 'Immediate protection to prevent further water damage'
    },
    {
      icon: 'ri-file-shield-line',
      title: 'Insurance Claims',
      description: 'Complete documentation and assistance with claims'
    },
    {
      icon: 'ri-tools-line',
      title: 'Full Restoration',
      description: 'Complete repair from minor fixes to full replacement'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Emergency',
      description: 'Round-the-clock response for storm emergencies'
    }
  ];

  const stats = [
    { number: '2 Hours', label: 'Average Response Time' },
    { number: '1000+', label: 'Storm Repairs Completed' },
    { number: '98%', label: 'Insurance Approval Rate' }
  ];

  return (
    <section id="storm-damage" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Image */}
          <div className="lg:order-1 order-2">
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/68d80a1ed7165b5028021a6816877498.jpg"
                  alt="Storm Damage Repair"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Emergency Badge */}
              <div className="absolute top-8 right-8 bg-red-600 text-white px-6 py-3 rounded-full shadow-xl">
                <div className="flex items-center">
                  <i className="ri-alarm-warning-line text-xl mr-2 animate-pulse"></i>
                  <span className="font-bold text-sm whitespace-nowrap">24/7 Emergency</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="lg:order-2 order-1">
            <span className="inline-block px-4 py-1.5 rounded-full bg-orange-100 text-orange-600 text-xs font-bold uppercase tracking-wider mb-4">
              STORM DAMAGE REPAIR
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Fast Response When Storms Strike
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Florida weather can be unpredictable and destructive. When hurricanes, tropical storms, or severe weather damage your roof, we respond immediately to protect your home and begin the restoration process.
            </p>

            {/* Services Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10">
              {services.map((service, index) => (
                <div key={index} className="bg-white rounded-xl p-5 shadow-md hover:shadow-lg transition-shadow">
                  <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-3">
                    <i className={`${service.icon} text-orange-600 text-xl`}></i>
                  </div>
                  <h3 className="text-base font-bold text-gray-900 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {service.description}
                  </p>
                </div>
              ))}
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mb-8 bg-gray-50 rounded-2xl p-6">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-orange-600 mb-1">
                    {stat.number}
                  </div>
                  <div className="text-xs text-gray-600">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            {/* CTA */}
            <a
              href="#contact"
              className="inline-flex items-center px-8 py-4 bg-orange-600 text-white text-base font-semibold rounded-full hover:bg-orange-700 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Get Emergency Service
              <i className="ri-arrow-right-line ml-3 text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}